import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { QuestionProps } from "../../../typings/register";
import { RootState } from "../../../redux/store";
import { HOMEPAGE } from "../../../navigation/Constants";
import { saveAboutMemberDescription } from "../../../services/memberService";
import EditTextField from "../../../components/EditTextField";
import { setSignupData } from "../../../redux/signup";

export interface QuestionTagProps {
   question: QuestionProps;
   next: () => void;
}
const AboutMeQuestion = (props: any) => {

   let history = useHistory();
   const dispatch = useDispatch();
   const register = useSelector((state: RootState) => state.signup);
   const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 13));
   // const { question, next }: QuestionTagProps = props;
   // const [text, setText] = useState<string>("");
   // const member = useSelector((state: RootState) => state.member);
   // const [errors, setErrors] = useState<any>({});


   const onSave = async (value: string) => {
      //   await saveAboutMemberDescription(member.memberCode, value);
      register.aboutMe = value;
      dispatch(setSignupData(register));
      if (props.hasNext()) props.next();
      // else
      // history.goBack();
      //history.push(HOMEPAGE); 
   };


   return (
      <>
         <EditTextField
            buttonText={"אפשר להמשיך"}
            subtitle={question[0].questionSubTitle}
            title={question[0].question}
            value={register.aboutMe}
            onSave={onSave}
            isSkip={true}
         />
      </>
   )
}


export default AboutMeQuestion;